/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CEventLinkType {
    LINK = 'LINK',
    MAILTO = 'MAILTO',
}
